import { SvgIcon, type SvgIconProps } from '@components/primitives/SvgIcon';

import List from '../assets/icons/custom/List.svg?react';

export function ListIcon(props: SvgIconProps) {
  return <SvgIcon component={List} inheritViewBox {...props} />;
}
